import React from 'react';
import { cn } from '../../lib/utils'; // or use clsx

export const ButtonX = ({ className = '', children, ...props }: any) => {
  return (
    <button
      className={cn('rounded font-medium transition-all', className)}
      {...props}
    >
      {children}
    </button>
  );
};
